"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLevelPoolsWithUserAmount = exports.LevelPoolsWithUserAmountProvider = void 0;
var constate_1 = __importDefault(require("constate"));
var react_1 = require("react");
var web3_utils_1 = require("web3-utils");
var _LaunchpadProvider_1 = require("../../LaunchpadProvider");
var _abi_1 = require("../../abi");
var _launchpadConstants_1 = require("../../launchpadConstants");
var _shared_1 = require("../../shared");
var utils_1 = require("../../shared/utils");
var multicall_1 = require("../../shared/utils/multicall");
function useLevelPoolsWithUserAmountRaw(_a) {
    var levelPools = _a.levelPools;
    var account = (0, _shared_1.useUser)().account;
    var mainToken = (0, _LaunchpadProvider_1.useLaunchpadProvider)().mainToken;
    var lvlManagerAddress = (0, _shared_1.useRegistryContractAddress)('levelManager').addresses[0];
    var _b = (0, react_1.useState)([]), poolsState = _b[0], setPoolsState = _b[1];
    (0, _shared_1.useEffectWithWeb3)(function (web3) {
        if (!account)
            return;
        var calls = levelPools.flatMap(function (p) { return [
            {
                address: lvlManagerAddress,
                name: 'getUserPoolAmount',
                params: [account, p.address],
                contractName: 'LevelManager',
            },
            {
                address: p.address,
                name: 'getUnlocksAt',
                params: [account],
                contractName: 'Staking',
            },
        ]; });
        (0, multicall_1.multicallv2)({
            web3: web3,
            abi: {
                LevelManager: _abi_1.CONTRACTS.levelManager.v4.abi,
                Staking: _abi_1.CONTRACTS.staking.v2.abi,
            },
            calls: calls,
            options: { unwrapValues: true },
        }).then(function (results) {
            setPoolsState(levelPools.map(function (p, i) { return (__assign(__assign({}, p), { amount: (0, utils_1.normalizeDecimals)((0, web3_utils_1.toBN)(results[i * 2]), mainToken.decimals), unlocksAt: parseInt(results[i * 2 + 1], 10), isUnlocked: parseInt(results[i * 2 + 1], 10) < Date.now() / 1000 })); }));
        });
    }, [account]);
    return {
        total: Object.values(poolsState).reduce(function (acc, v) { return acc.add(v.amount); }, _launchpadConstants_1.ZERO_BN),
        poolsState: poolsState,
    };
}
var _a = (0, constate_1.default)(useLevelPoolsWithUserAmountRaw), LevelPoolsWithUserAmountProvider = _a[0], useLevelPoolsWithUserAmount = _a[1];
exports.LevelPoolsWithUserAmountProvider = LevelPoolsWithUserAmountProvider;
exports.useLevelPoolsWithUserAmount = useLevelPoolsWithUserAmount;
